'use strict';

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/helpers/isPrimitive.js
 ** module id = 2906
 ** module chunks = 0
 **/